/*
 * Define a form page allowing the user to enter the activity begin date.
 */
import css from './pages.module.css'
import { approxDateMessage } from '../validators/dateYup'
import { datePage } from './datePage'

export const activityBeginDatePage = propOverrides => {
  const props = {
    pageId: 'date_of_activity_page',
    fieldName: 'date_of_activity',
    required: true,
    label: 'When did the activity occur?',
    hint: approxDateMessage,
    labelClassName: css.largeDateLabel,
    ...propOverrides
  }

  return datePage(props)
}
